import { render } from "./TeachingDetail.vue?vue&type=template&id=7dc8b90d&scoped=true"
import script from "./TeachingDetail.vue?vue&type=script&lang=js"
export * from "./TeachingDetail.vue?vue&type=script&lang=js"

import "./TeachingDetail.vue?vue&type=style&index=0&id=7dc8b90d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7dc8b90d"

export default script